export class NavigationFilter {
    private nvaigation: any[];

    public constructor(navigations: any[]) {
        this.nvaigation = navigations;
    }

    public NavigationItemsFilter(characteristics: any[]) {
        this.nvaigation.forEach((element) => {
            if(Array.isArray(element.name)) {
                let filteredCharacteristics = characteristics.filter(c => c.code === element.name[0] || c.code === element.name[1])
                if(filteredCharacteristics.length === 2) {
                    element.success = true;
                    element.warning = false;
                    // element.required = false;
                } else {
                    element.success = false;
                    element.warning = false;
                    // element.required = false;
                }
            } else {
                const characteristic = characteristics.filter((x) => x.code === element.name)[0];
                if (characteristic != null && typeof characteristic !== 'undefined') {
                    element.success = true;
                    element.warning = false;
                    // element.required = false;
                } else {
                    element.success = false;
                    element.warning = false;
                    // element.required = false;
                }
            }
        });

        return this.nvaigation;
    }
}

export const modelSelectionNavigationItemsInit = [
    {
        displayText: 'modelle',
        name: 'KTU_MM_MODELL',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'artikelnummers',
        name: 'KTU_MM_ARTIKELNR',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'hauptfunktion',
        name: 'KTU_MM_HAUPTFUNKTION',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'anwendung',
        name: 'KTU_MM_ANWENDUNG',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'werkstoffTur',
        name: 'KTU_MM_WERKSTOFF',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'werkstoffZarge',
        name: 'KTU_MM_ZARGEN_WERKSTOFF',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    /* {
        displayText: '',
        name: 'KTU_MM_TUERART',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: '',
        name: 'KTU_MM_OEFFNUNGSART',
        status: '',
        success: false,
        warning: false,
        required: false,
    }, */
    {
        displayText: 'bauform',
        name: ['KTU_MM_OEFFNUNGSART', 'KTU_MM_KOMBI_ST_OL'],
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'einbruchschutz',
        name: 'KTU_MM_FUNKTION_RC',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'brandschutz',
        name: 'KTU_MM_FUNKTION_BH',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'rauchschutz',
        name: 'KTU_MM_FUNKTION_RH',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'warmeschutz',
        name: 'KTU_MM_FUNKTION_WS',
        status: '',
        success: false,
        warning: false,
        required: false,
    },    
    {
        displayText: 'schallschutz',
        name: 'KTU_MM_FUNKTION_S',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'klimaklasse',
        name: 'KTU_MM_FUNKTION_KK',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'turblattdicke',
        name: 'KTU_MM_TUERBLATT_DICKE',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'hochsicherheitstur',
        name: 'KTU_MM_FUNKTION_VSOE',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'panikturEN1125',
        name: 'KTU_MM_PANIK',
        status: '',
        success: false,
        warning: false,
        required: false,
    }, 
    {
        displayText: 'fluchtturEN179',
        name: 'KTU_MM_FLUCHT',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: 'modellreihe',
        name: 'CUST_MM_MODELLREIHE',
        status: '',
        success: false,
        warning: false,
        required: false,
    },    
];

export const modelSelectionNavigationItems = [
    {
        displayText: 'modelle',
        name: 'KTU_MM_MODELL',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'artikelnummers',
        name: 'KTU_MM_ARTIKELNR',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'hauptfunktion',
        name: 'KTU_MM_HAUPTFUNKTION',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'anwendung',
        name: 'KTU_MM_ANWENDUNG',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'werkstoffTur',
        name: 'KTU_MM_WERKSTOFF',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'werkstoffZarge',
        name: 'KTU_MM_ZARGEN_WERKSTOFF',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    /* {
        displayText: '',
        name: 'KTU_MM_TUERART',
        status: '',
        success: false,
        warning: false,
        required: false,
    },
    {
        displayText: '',
        name: 'KTU_MM_OEFFNUNGSART',
        status: '',
        success: false,
        warning: false,
        required: false,
    }, */
    {
        displayText: 'bauform',
        name: ['KTU_MM_OEFFNUNGSART', 'KTU_MM_KOMBI_ST_OL'],
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'einbruchschutz',
        name: 'KTU_MM_FUNKTION_RC',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'brandschutz',
        name: 'KTU_MM_FUNKTION_BH',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'rauchschutz',
        name: 'KTU_MM_FUNKTION_RH',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'warmeschutz',
        name: 'KTU_MM_FUNKTION_WS',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'schallschutz',
        name: 'KTU_MM_FUNKTION_S',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'klimaklasse',
        name: 'KTU_MM_FUNKTION_KK',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'turblattdicke',
        name: 'KTU_MM_TUERBLATT_DICKE',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'hochsicherheitstur',
        name: 'KTU_MM_FUNKTION_VSOE',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'panikturEN1125',
        name: 'KTU_MM_PANIK',
        status: '',
        success: false,
        warning: false,
        required: true,
    },  
    {
        displayText: 'fluchtturEN179',
        name: 'KTU_MM_FLUCHT',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
    {
        displayText: 'modellreihe',
        name: 'CUST_MM_MODELLREIHE',
        status: '',
        success: false,
        warning: false,
        required: true,
    },
];



